export default __webpack_public_path__ + "static/media/hotService3.2829a3de.svg";